// Handlers
import handleReturn from './handleReturn';

export default () => ({
    handleReturn,
});
